// Shared meal-option constants used by BOTH the manual meal editor
// (src/pages/admin/MealEditor.jsx) and the bulk import review UI
// (src/pages/admin/AdminMealImport.jsx).
//
// Keeping these in one module guarantees both flows produce values that are
// consistent across the whole meal library — no "gluten_free" in one place
// and "gluten-free" in another, no ad-hoc cuisine names, etc.

export const COOKWARE_OPTIONS = [
  { id: 'oven', label: 'Oven' },
  { id: 'stovetop', label: 'Stovetop' },
  { id: 'air_fryer', label: 'Air Fryer' },
  { id: 'instant_pot', label: 'Instant Pot' },
  { id: 'microwave', label: 'Microwave' },
  { id: 'grill', label: 'Grill' },
  { id: 'blender', label: 'Blender' },
  { id: 'no_cook', label: 'No Cook Required' },
];

export const CUISINE_OPTIONS = [
  { id: 'american', label: 'American' },
  { id: 'mexican', label: 'Mexican' },
  { id: 'italian', label: 'Italian' },
  { id: 'asian', label: 'Asian' },
  { id: 'mediterranean', label: 'Mediterranean' },
  { id: 'indian', label: 'Indian' },
  { id: 'japanese', label: 'Japanese' },
  { id: 'chinese', label: 'Chinese' },
  { id: 'thai', label: 'Thai' },
  { id: 'greek', label: 'Greek' },
  { id: 'middle_eastern', label: 'Middle Eastern' },
  { id: 'french', label: 'French' },
  { id: 'korean', label: 'Korean' },
  { id: 'vietnamese', label: 'Vietnamese' },
  { id: 'other', label: 'Other' },
];

export const PROTEIN_OPTIONS = [
  { id: 'chicken', label: 'Chicken' },
  { id: 'beef', label: 'Beef' },
  { id: 'pork', label: 'Pork' },
  { id: 'turkey', label: 'Turkey' },
  { id: 'fish', label: 'Fish' },
  { id: 'seafood', label: 'Seafood' },
  { id: 'eggs', label: 'Eggs' },
  { id: 'tofu', label: 'Tofu' },
  { id: 'legumes', label: 'Legumes/Beans' },
  { id: 'vegetarian', label: 'Vegetarian' },
  { id: 'vegan', label: 'Vegan' },
  { id: 'none', label: 'No Protein' },
];

export const DEFAULT_UNIQUENESS_GROUPS = [
  'Smoothies', 'Salads', 'Sandwiches', 'Wraps', 'Bowls', 'Oatmeal', 'Yogurt Bowls',
];
